import React from 'react'
import { useHistory } from 'react-router-dom'

import usePermissions from 'hooks/usePermissions'

import {
  Divider,
  Box,
  Card,
  CircularProgress,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core'

import { NoData } from 'components'

import { Archive } from 'react-feather'

import constants from 'constants/index'
import styles from './styles'
import qs from 'qs'

const useStyles = makeStyles(styles)

const ResumeCard = ({ resumes = [], isLoading }) => {
  const classes = useStyles()
  const history = useHistory()
  const permissions = usePermissions()

  const canAccessDataProcesses = permissions.some([
    constants.permissions.DATA_PROCESSES.CREATE,
    constants.permissions.DATA_PROCESSES.LIST,
  ])

  const statusRows = constants.dataProcess.DATA_PROCESS_RESUME_STATUS_ROWS

  const ListItemLink = (props) => {
    return <ListItem button component="a" {...props} />
  }

  const handleClickStatus = (statusId, departmentId) => {
    history.push({
      pathname: '/data-processes',
      search: qs.stringify(
        { statusId: statusId, departmentId: departmentId },
        { arrayFormat: 'repeat' },
      ),
    })
  }

  const handleClickAll = (departmentId) => {
    history.push({
      pathname: '/data-processes',
      search: qs.stringify({ departmentId: departmentId }),
    })
  }

  const handleClickRow = (row, departmentId) => {
    if (row.statusId === null) {
      return handleClickAll(departmentId)
    }

    return handleClickStatus(row.statusId, departmentId)
  }

  return (
    <>
      {isLoading ? (
        <Box
          display="flex"
          width="100%"
          minHeight="700px"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {resumes &&
            resumes?.map((resume) => {
              return (
                <Grid
                  item
                  xl={4}
                  lg={4}
                  md={4}
                  sm={6}
                  xs={12}
                  key={resume?.departament?.id}
                  id={constants.dataProcess.DATA_PROCESS_RESUME_DRIVER_STEP_3}
                >
                  <Card className={classes.cardPadding}>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Archive size={22} />
                      <Box ml={1}>
                        <Tooltip title={resume?.departament?.name}>
                          <Typography
                            variant="h5"
                            className={classes.departmentEllipsis}
                          >
                            {resume?.departament?.name}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </Box>
                    <List component="nav">
                      {statusRows.map((row, index) => (
                        <React.Fragment key={row.label}>
                          <ListItemLink
                            disabled={!canAccessDataProcesses}
                            onClick={() =>
                              handleClickRow(row, resume?.departament?.id)
                            }
                          >
                            <ListItemText
                              primary={row.label}
                              primaryTypographyProps={{
                                variant: 'body1',
                              }}
                            />
                            <Chip
                              className={classes[row.chipClassKey]}
                              label={resume?.resume?.[row.resumeKey]}
                            />
                          </ListItemLink>
                          {index < statusRows.length - 1 && <Divider />}
                        </React.Fragment>
                      ))}
                    </List>
                  </Card>
                </Grid>
              )
            })}
          <Grid item sm={12}>
            {!resumes?.length && (
              <NoData message="Nenhum dado foi encontrado." />
            )}
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default ResumeCard
